var ur = window.location.href;
if (ur.includes("/product") && document.querySelector("html").classList.contains("vwo-tests")) {
  const disableFramingClass = () => {
    const digitalFileBtns = document.querySelectorAll('.vwo-tests :not(#s) .w-full.variant-option button[data-value="Digital File"].border--focus').length;
    document.querySelectorAll(".Choose.your.premium.framing").forEach(element => {
      element.classList.toggle("disabled", digitalFileBtns);
    });
  };
  setInterval(disableFramingClass, 100);

  window.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add(window.location.href.includes("1-pet") ? "one-pet" : "two-pet");

    const setCustomBackground = () => {
    document.querySelectorAll(".w-full.variant-option.Background button").forEach(button => {
      button.addEventListener("click", function() {
        if (window.location.href.includes("1-pet")) {
          document.body.classList.toggle("custom-background", this.getAttribute("data-value") === "Custom");
        }
      });
    });
    };

    const initialSetCustomBackground = () => {
      if (window.location.href.includes("1-pet")) {
        const customElement = document.querySelector(".w-full.variant-option.Background button.border--focus[data-value='Custom']");
        if (customElement) {
          document.body.classList.add("custom-background");
        }
      }
    };

    initialSetCustomBackground();
    setTimeout(initialSetCustomBackground, 100);
    setCustomBackground();

    document.querySelectorAll(".shopify-product-form").forEach(form => {
      form.setAttribute("material", "POSTER");
    });

    const buttons = document.querySelectorAll("#poster-framing-option button");
    if (buttons.length) buttons[0].click();

    document.querySelectorAll(".material-option").forEach(option => {
      option.addEventListener("click", function() {
        document.querySelector(".material-option.selected")?.classList.remove("selected");
        this.classList.add("selected");
        const material = this.textContent.trim();
        document.querySelector(".shopify-product-form").setAttribute("material", material);
        
        console.log(`#${material.toLowerCase()}-framing-option button`);

        if (material === "CANVAS" && window.location.href.includes("1-pet") && document.body.classList.contains("custom-background")) {
          if (document.querySelector(`button[data-value='8" x 10"'].border--focus`)) {
            document.querySelectorAll(`.variant-option button[data-value='12" x 16"']`)[0].click();
            document.body.classList.add("one-pet-only");
          }
        }

        if (material === "POSTER" && document.querySelector(`button[data-value='24" x 32"'].border--focus`)) {
          document.querySelectorAll(`.variant-option button[data-value='18" x 24"']`)[0].click();
        }

        document.querySelector(`#${material.toLowerCase()}-framing-option button`).click();
      });
    });

    const element = document.querySelector('.type__nav [href="/products/cartoon-my-pet-portrait"]');
    if (element) element.href = "https://printedpetmemories.com/products/custom-pet-portrait";

    if (document.querySelectorAll('.button-controls-container').length === 0) {
      setTimeout(() => {
        const container = document.querySelector("main .variant-option.Choose.Your.Background.Style > div.flex.flex-wrap.w-full");
        if (container) {
          const customDiv = document.createElement('div');
          customDiv.className = 'pet-name-custom';
          customDiv.innerHTML = `
              <span class="pet-name-label">Describe Background*</span>
              <input type="text" id="pet-color-custom" maxlength="100" placeholder="Beach and sunset" name="properties[Custom Background]">
              <span class="required-alert" style="display: none">This field is required</span>`;
          container.appendChild(customDiv);
        }

        document.querySelectorAll(".vwo-tests :not(#s) .w-full.variant-option.Style button").forEach(button => {
          button.addEventListener('click', () => {
            if (button.getAttribute("data-value") !== "Custom") {
              const petColorInput = document.getElementById("pet-color-custom");
              if (petColorInput) {
                petColorInput.value = "";
                petColorInput.dispatchEvent(new Event('change'));
              }
            }
          });
        });

        const firstVariantOption = document.querySelector(".variant-option.How.many.pets");
        const firstButton = document.querySelector("button.btn.btn--small.btn--plain.border--focus");
        if (firstVariantOption && firstButton) {
          firstVariantOption.setAttribute("data-style", firstButton.getAttribute("data-value"));
        }

        document.querySelectorAll(".w-full.pr-variant-option.variant-option.Choose.your.portrait.style button").forEach(button => {
          button.addEventListener('click', () => {
            const parentOptions = button.closest(".options");
            if (parentOptions) {
              const howManyPetsOption = parentOptions.querySelector(".variant-option.How.many.pets");
              if (howManyPetsOption) {
                howManyPetsOption.setAttribute("data-style", button.getAttribute("data-value"));
              }
            }
          });
        });
      }, 1000);

      if (document.querySelector('section[id*="pet-portrait"]')) {
        const firstVariantOption = document.querySelector(".w-full.variant-option");
        if (firstVariantOption) firstVariantOption.classList.add("active");
      }

      let uppp = 0;
      const timeruppp = setInterval(() => {
        if (document.querySelectorAll("main .uploadkit-button").length) {
          if (!document.querySelectorAll(".pet-name-toggle").length) {
            // Create the Pet Features label element
            const petFeaturesLabel = document.createElement('label');
            petFeaturesLabel.className = 'pet-features';
            petFeaturesLabel.innerText = 'Pet Features';

            // Get the parent node where elements will be inserted
            const parentNode = document.querySelector("main .uploadkit");
            if (parentNode) {
              parentNode.insertBefore(petFeaturesLabel, parentNode.firstChild);
            }

            ["Name & Features - Photo 1", "Name & Features - Photo 2", "Name & Features - Photo 3"].forEach((label, index) => {
              const uploader = document.querySelectorAll("main .uploadkit .uploadkit-uploader")[index];
              const petNameToggle = document.createElement('div');
              petNameToggle.className = 'pet-name-toggle';
              petNameToggle.innerHTML = `<span class="pet-name-label">${label}</span><input type="text" id="pet-name" placeholder="Mila, Golden Cavapoo, white patch on ear" name="properties[Pet Name and Features ${index + 1}]">`;
              if (uploader) uploader.parentNode.insertBefore(petNameToggle, uploader);
            });
          }
          clearInterval(timeruppp);
        }
        if (++uppp > 200) clearInterval(timeruppp);
      }, 50);

      const htmlContent = `
          <div class="form-footer-container">
            <div class="subtotal-container">
              <div>Subtotal: <b></b></div>
              <p>Free Revisions</p>
            </div>
            <div class="button-controls-container">
              <span id="back-button">
                <svg width="32" height="16" viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M31 9C31.5523 9 32 8.55228 32 8C32 7.44772 31.5523 7 31 7V9ZM0.292891 7.29289C-0.0976334 7.68342 -0.0976334 8.31658 0.292891 8.70711L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.46159 1.95262 8.46159 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292891 7.29289ZM31 7L0.999998 7V9L31 9V7Z" fill="white"/>
                </svg>
              </span>
              <span id="next-button">Next 👉</span>
              <span id="next-button" class="add-to-cart" style="display: none;">
                <b>Add to Cart 👉</b>
                <div class="btn__spinner">
                  <b class="inline-flex align-middle " aria-hidden="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-loader"><line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line></svg>
                  </b>
                </div>
              </span>
            </div>
          </div>
        `;

        const productAddElement = document.querySelector(".product-add");
        if (productAddElement) {
          productAddElement.insertAdjacentHTML('afterend', htmlContent);
        }

      if (document.querySelector(".w-full.pr-variant-option.variant-option.Choose.your.portrait.style.active")) {
        document.getElementById("back-button").style.display = "none";
      }
    }

    setTimeout(() => {
      const addButton = document.querySelector('#next-button.add-to-cart');

      if (addButton) {
        addButton.addEventListener('click', function(event) {
          event.preventDefault();

          const selectedProducts = [];
          document.querySelectorAll('.addon-checkbox:checked').forEach((checkbox) => {
            const variantId = parseInt(checkbox.getAttribute('data-id'));
            console.log('Selected Variant ID:', variantId);

            if (!isNaN(variantId)) {
              selectedProducts.push({
                id: variantId,
                quantity: 1
              });
            }
          });

          if (selectedProducts.length > 0) {
            console.log('Final Selected Products:', selectedProducts);
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({ items: selectedProducts })
            })
            .then(async response => {
              let data = await response.json();
              if (response.ok) {
                document.querySelector(".shopify-product-form button[type=submit]").click();
                console.log('Addon successfully added to cart');
              } else {
                console.error('Error adding addon to cart:', data || 'Unknown error');
              }
            }).catch(error => {
              console.error('Network error:', error);
            });
          } else {
            document.querySelector(".shopify-product-form button[type=submit]").click();
          }
        });
      }
    }, 1000);

    setInterval(() => {
      const subtotalContainer = document.querySelector(".subtotal-container b");
      const sellingPriceElement = document.querySelector(".fx-selling-price");

      if (!subtotalContainer || !sellingPriceElement) {
        return;
      }

      const currentPrice = parseFloat(
        sellingPriceElement.textContent.replace(/[^0-9.-]/g, "")
      );

      if (Number.isNaN(currentPrice)) {
        return;
      }

      const checkboxes = Array.from(
        document.querySelectorAll(
          ".ast-addon-item input[type=checkbox]"
        )
      );

      const addonTotal = checkboxes.reduce((total, checkbox) => {
        if (!checkbox.checked) {
          return total;
        }

        const addonItem = checkbox.closest(".ast-addon-item");
        const priceElement = addonItem?.querySelector(
          ".ast-bundle-item-price"
        );

        if (!priceElement) {
          return total;
        }

        const addonPrice = parseFloat(
          priceElement.textContent.replace(/[^0-9.-]/g, "")
        );

        return total + (Number.isNaN(addonPrice) ? 0 : addonPrice);
      }, 0);

      subtotalContainer.textContent =
        "$" + (currentPrice + addonTotal).toFixed(2);
    }, 100);

    document.getElementById("back-button").addEventListener("click", e => {
      var element = document.querySelector("h1.type__heading");
      var offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - 100;
      if (window.innerWidth > 768) {
        offsetPosition = 0;
      }
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    });

    document.querySelector("span#next-button.add-to-cart").addEventListener("click", function() {
      this.classList.add("btn--loading");
      const ccount = document.querySelector('[x-text="cart.item_count"]').innerHTML;
      let addde = 0;
      const timeraddde = setInterval(() => {
        if (ccount !== document.querySelector('[x-text="cart.item_count"]').innerHTML) {
          document.querySelector("span#next-button.add-to-cart").classList.remove("btn--loading");
          clearInterval(timeraddde);
        }
        if (++addde > 75) {
          document.querySelector("span#next-button.add-to-cart").classList.remove("btn--loading");
          clearInterval(timeraddde);
        }
      }, 50);
    });

    document.getElementById("next-button").addEventListener("click", e => {
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (document.querySelector('.vwo-tests section[is-stepper] .w-full.variant-option.Choose.your.portrait button[data-value="Royal"].border--focus') && 
        window.location.href.includes("custom-pet-portrait")) {
        window.location.href = "https://petportraits.com/products/royal-pet-portrait";
        document.querySelector(".w-full.pr-variant-option.variant-option.Number.of.Pets.How.many.pets.in.your.portrait.active").style.display = 'none';
      }

      var element = document.querySelector("h1.type__heading");
      var offsetPosition = element.getBoundingClientRect().top + window.pageYOffset - 100;
      if (window.innerWidth > 768) {
        offsetPosition = 0;
      }
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });

      if (document.querySelector(".uploadkit-invalid") && document.querySelector(".product-add").classList.contains("active")) {
        // Add logic for moving to next step
      } else {
        if (
          document.querySelectorAll(".w-full.pr-variant-option.variant-option.How.many.pets.active").length > 0
        ) {
          var ind = document.querySelector('select[name="id"]').selectedIndex;
          document.getElementById("back-button").style.display = 'none';
        
          window.location.href = document.querySelector('select[name="id"] option:nth-child(' + (ind + 1) + ')').getAttribute("data-product-url");
        } else {
          if (document.querySelectorAll(".pet-size-image").length > 0) {
            window.location.href = document.querySelector(".pet-size-image.selected").getAttribute("href");
          }
          const customInput = document.querySelector(':not(#s) .w-full.variant-option.Choose.Your.Background.Style button.border--focus[data-value="Custom"]+.pet-name-custom input');
          const requiredAlert = document.querySelector(".required-alert");
          const form_hide = document.querySelector(".hide__custom_form");
          if (customInput && customInput.value == "" && form_hide) {
             if (document.querySelector(".product-add").classList.contains("active")) {
              // If '.product-add' has 'active' class, remove it and add 'last-step' class to '.shopify-product-form'
              document.querySelector(".product-add").classList.remove("active");
              document.querySelector(".conv-check-list").style.display = 'none';
              document.querySelector(".shopify-product-form").classList.add("last-step");
            } else if (document.querySelectorAll(".pr-variant-option.active").length == 2) {
              // If there are two '.pr-variant-option.active' elements, remove 'active' class from all and add 'active' class to '.product-add'
              document.querySelectorAll(".pr-variant-option").forEach(function (elem) {
                elem.classList.remove("active");
              });
              document.querySelector(".product-add").classList.add("active");
              document.querySelector(".conv-check-list").style.display = 'block';
            } else if (document.querySelectorAll(".pr-variant-option + .pr-variant-option").length > 0) {
              if (document.querySelectorAll('.w-full.pr-variant-option.variant-option.Choose.your.portrait.style.active').length > 0) {
                // If any '.w-full.pr-variant-option.variant-option.Choose.your.portrait.style.active' element exists, show '#back-button'
                document.querySelector("#back-button").style.display = "flex";
              }

              // Remove 'active' class from all '.pr-variant-option' and add 'active' class to '.pr-variant-option + .pr-variant-option'
              document.querySelectorAll(".pr-variant-option").forEach(function (elem) {
                elem.classList.remove("active");
              });
              document.querySelectorAll(".pr-variant-option + .pr-variant-option").forEach(function (elem) {
                elem.classList.add("active");
              });
            }
          }
          else if (customInput && customInput.value == "") {
            requiredAlert.classList.add("show-required");
          } else {
            if (requiredAlert) {
              requiredAlert.classList.remove("show-required");
            }
            if (document.querySelector(".product-add").classList.contains("active")) {
              // If '.product-add' has 'active' class, remove it and add 'last-step' class to '.shopify-product-form'
              document.querySelector(".product-add").classList.remove("active");
              document.querySelector(".conv-check-list").style.display = 'none';
              document.querySelector(".shopify-product-form").classList.add("last-step");
            } else if (document.querySelectorAll(".pr-variant-option.active").length == 2) {
              // If there are two '.pr-variant-option.active' elements, remove 'active' class from all and add 'active' class to '.product-add'
              document.querySelectorAll(".pr-variant-option").forEach(function (elem) {
                elem.classList.remove("active");
              });
              document.querySelector(".product-add").classList.add("active");
              document.querySelector(".conv-check-list").style.display = 'block';
            } else if (document.querySelectorAll(".pr-variant-option + .pr-variant-option").length > 0) {
              if (document.querySelectorAll('.w-full.pr-variant-option.variant-option.Choose.your.portrait.style.active').length > 0) {
                // If any '.w-full.pr-variant-option.variant-option.Choose.your.portrait.style.active' element exists, show '#back-button'
                document.querySelector("#back-button").style.display = "flex";
              }

              // Remove 'active' class from all '.pr-variant-option' and add 'active' class to '.pr-variant-option + .pr-variant-option'
              document.querySelectorAll(".pr-variant-option").forEach(function (elem) {
                elem.classList.remove("active");
              });
              document.querySelectorAll(".pr-variant-option + .pr-variant-option").forEach(function (elem) {
                elem.classList.add("active");
              });
            }
          }
        }
      }
    });

    document.getElementById("back-button").addEventListener('click', e => {
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (window.location.href.includes("portrait-digital") && (document.querySelector(".Style.active"))) {
        window.location.href = "/products/custom-pet-portrait-digital";
      }
      else if (document.querySelector(".Style.active")) {
        window.location.href = "/products/custom-pet-portrait-v2";
      }
      const shopifyProductForm = document.querySelector(".shopify-product-form");
      if (shopifyProductForm && shopifyProductForm.classList.contains("last-step")) {
        document.querySelector(".product-add").classList.add("active");
        document.querySelector(".conv-check-list").style.display = 'block';
        shopifyProductForm.classList.remove("last-step");
      } else if (document.querySelectorAll(".pr-variant-option.active").length == 2) {
        document.querySelectorAll(".pr-variant-option").forEach(function (element) {
          element.classList.remove("active");
        });
        document.querySelectorAll(".pr-variant-option")[0].classList.add("active");
      } else if (document.querySelector(".product-add").classList.contains("active")) {
        var prVariantOptions = document.querySelectorAll(".pr-variant-option");
        prVariantOptions[1].classList.add("active");
        prVariantOptions[2].classList.add("active");
        document.querySelector(".product-add").classList.remove("active");
        document.querySelector(".conv-check-list").style.display = 'none';
      } else if (document.querySelectorAll(".w-full.pr-variant-option.variant-option.How.many.pets.active").length) {
        document.querySelector(".w-full.pr-variant-option.variant-option.Choose.your.portrait.style").classList.add("active");
        document.querySelector(".w-full.pr-variant-option.variant-option.How.many.pets").classList.remove("active");
      }

      if (document.querySelectorAll(".w-full.pr-variant-option.variant-option.Choose.your.portrait.style.active").length) {
        console.log("here");
        document.getElementById("back-button").style.display = 'none';
      }
    });
  });
}

// Move popup content
const popupElement = document.querySelector('#size-guide-content');
const variantOptions = document.querySelectorAll('.variant-option');

let labelElement = null;
variantOptions.forEach(option => {
  if (option.className.match(/size/i)) { // case-insensitive match for 'size'
    labelElement = option.querySelector('label');
  }
});

if (labelElement && popupElement) {
  labelElement.appendChild(popupElement);
  popupElement.classList.add('popup-moved');
}
document.querySelectorAll('.conv-check-list a, .variant-option a.frame-link').forEach(anchor => {
  anchor.addEventListener('click', e => {
    e.preventDefault();
    setTimeout(() => {
      const targetId = anchor.classList.contains('frame-link') ? 'frame-guide-content' : 'photo-guide-content';
      document.getElementById(targetId).click();
    }, 100);
  });
});


// Function to toggle display based on button state
function toggleDisplay(btn) {
  setTimeout(() => {
    const isFocused = btn.classList.contains("border--focus");
    const dataValue = btn.getAttribute("data-value");
    const targetElement = document.querySelector("[hide-this-options]");
    const uploaderBtns = document.querySelectorAll(
      ".hide-uploadbtn .uploadkit .uploadkit-uploader"
    );
    const chooseCanvasElements = document.querySelectorAll(".reverseit");

    console.log("isFocused", isFocused);
    console.log("dataValue", dataValue);

    if (isFocused) {
      switch (dataValue) {
        case "One":
          updateCanvasState(chooseCanvasElements, false);
          setDisplay([targetElement], "block");
          setDisplay([uploaderBtns[2], uploaderBtns[1]], "none");
          break;
        case "Two":
          updateCanvasState(chooseCanvasElements, true);
          setDisplay([targetElement], "none");
          setDisplay([uploaderBtns[2]], "none");
          setDisplay([uploaderBtns[1]], "block");
          break;
        case "Three":
          updateCanvasState(chooseCanvasElements, true);
          setDisplay([targetElement], "none");
          setDisplay([uploaderBtns[2], uploaderBtns[1]], "block");
          break;
      }
    }
  }, 500);
}

// Helper function to update canvas text reverse state
function updateCanvasState(elements, reverse) {
  elements.forEach((element) => {
    element.classList.toggle("text-reverse", reverse);
  });
}

// Helper function for setting display style
function setDisplay(elements, display) {
  elements.forEach((element) => {
    if (element) element.style.display = display;
  });
}

document.querySelectorAll(".btn-special").forEach((btn) => {
  btn.addEventListener("click", () => {
    handleButtonClick(btn);
  });
  toggleDisplay(btn);
});

function handleButtonClick(btn) {
  toggleDisplay(btn);
  toggleDisplay2(btn);

  if (btn.classList.contains("number-of-pets")) {
    const dataIndex = Number(btn.getAttribute("data-index"));
    if (dataIndex > 1) {
      setTimeout(triggerCanvasActions, 500);
      setTimeout(reverseTextContent, 500);
    } else {
      revertTextContent();
    }
  }
}

function triggerCanvasActions() {
  const triggers = [
    ".choose-canvas-size-inches.trigger-canvas",
    ".choose-poster-size-inches.trigger-canvas",
    ".size-inches.trigger-canvas",
  ];
  triggers.forEach((selector) => {
    document.querySelectorAll(selector).forEach((el) => el.click());
  });
}

function reverseTextContent() {
  document.querySelectorAll(".btn.reverseit").forEach((chooseCanvas) => {
    if (!chooseCanvas.getAttribute("data-reversed")) {
      chooseCanvas.textContent = chooseCanvas.textContent
        .split("x")
        .reverse()
        .join("x");
      chooseCanvas.setAttribute("data-reversed", "true");
    }
  });
}

function revertTextContent() {
  document.querySelectorAll(".btn.reverseit").forEach((chooseCanvas) => {
    if (chooseCanvas.getAttribute("data-reversed")) {
      chooseCanvas.textContent = chooseCanvas.textContent
        .split("x")
        .reverse()
        .join("x");
      chooseCanvas.removeAttribute("data-reversed");
    }
  });
}

function toggleDisplay2(btn) {
  setTimeout(() => {
    const isFocused = btn.classList.contains("border--focus");
    const dataValue = btn.getAttribute("data-value");
    const targetElements = document.querySelectorAll("[hide-this-options-new]");
    const titleElement = document.querySelector(".vrimg--title-first");
    const triggerElement = document.querySelector(".trigger-after");

    console.log("isFocused", isFocused);
    console.log("dataValue", dataValue);

    if (isFocused) {
      switch (dataValue) {
        case '24"x32"':
          setDisplay(targetElements, "none");
          setDisplay([titleElement], "none");
          triggerElement && triggerElement.click();
          break;
        default:
          setDisplay(targetElements, "block");
          setDisplay([titleElement], "block");
          break;
      }
    }
  }, 500);
}

const btnSpecial3 = document.querySelector(".btn-special--3");
console.log("Button found:", btnSpecial3);

if (btnSpecial3) {
  btnSpecial3.insertAdjacentHTML("afterend", '<p class="vrimg--title">Framed Canvas:</p>');
  console.log("Paragraph added after button");
} else {
  console.log("Button with class .btn-special--3 not found");
}

document.querySelectorAll('.template-product a[href="#"].btn').forEach(anchor => {
  anchor.addEventListener('click', (event) => {
    event.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    return false;
  });
});